module.exports = __webpack_public_path__ + "static/media/background_road.131e7cc7.svg";